// Contas do Estúdio Social que aparecem na lista de Canais. A que já alimenta
// uma caixa não repete (a caixa já está na lista) e a desconectada sai: a
// lixeira só desconecta, então ela ficava na lista com "Reconectar" e parecia
// que excluir não funcionava (30/10, conta 77). Reconectar fica no Estúdio
// Social › Contas.
export const visibleSocialRows = (accounts = []) =>
  accounts.filter(
    account => !account.has_inbox && account.status !== 'disconnected'
  );
